import React, { Component } from 'react'
import Service from "../service"
import { withTranslation } from 'react-i18next';

class GoLive extends Component {

    state = {
        data: {}
    }

    // TODO THIS CAN BE MOVED TO SERVICE
    setSessionStorage({ whiteboardID, user_id }) {

        // TODO NEED TO CHECK IF THE BOARD IS ACTUALLY ONLINE OR NOT 
        sessionStorage.setItem(
            "boardinfo",
            JSON.stringify({
                isOnline: true,
                flow_id: whiteboardID,
                user_id,
                showBackButton: false,
            })
        );
    }

    async setWhiteBoardInfo({ whiteboardID, user_id }) {
        const { name, isOnline } = await Service.getWhiteBoardInfo({ whiteboardID });


        if (isOnline === false) {
            sessionStorage.setItem(
                "boardinfo",
                JSON.stringify({
                    isOnline: false,
                    flow_id: whiteboardID,
                    user_id,
                    showBackButton: false,
                })
            );
            return alert("teacher has not started the live session yet ");

        }
        let boardInfo = JSON.parse(sessionStorage.getItem("boardinfo"));
        boardInfo = { ...boardInfo, name };
        sessionStorage.setItem("boardinfo", JSON.stringify(boardInfo));
    }

    async componentDidMount() {
        const { whiteboardID } = this.props.match.params;
        const token = new URLSearchParams(this.props.location.search).get("token");

        let data = await Service.loginViaUserToken({ token });
        this.setState({ data });

        const user_id = this.state.data.kneura_id;
        this.setSessionStorage({ whiteboardID, user_id });

        await this.setWhiteBoardInfo({ whiteboardID, user_id });

        this.props.history.push({
            pathname: "/class",
            state: { boardInfo: JSON.parse(sessionStorage.getItem("boardInfo")) },
        });
    }

    render() {
        const { t } = this.props;
        return <h1>{t("Loading ...")}</h1>;
    }



}

export default withTranslation()(GoLive)